<section class="main-section dashboard-section">
  <div class="row align-items-end">
    <div class="col-md-10">
      <h2>Orders</h2>
    </div>
    <div class="col-md-2 text-right">
      <label><a style="color: #007bff;" (click)="openRequestPopUP()">Withdraw Request</a></label>
    </div>
  </div>
  <div class="row mb-4">
    <div class="col-md mb-2 mb-md-0" style="position: relative;">
      <div class="box">
        <h1 style="z-index: 1100;min-height: 40px !important;"><span>{{orders?.createdCount || 0}}</span>
          <small>New</small>
        </h1>
      </div>
    </div>
    <div class="col-md mb-2 mb-md-0" style="position: relative;">
      <div class="box">
        <h1 style="z-index: 1100;min-height: 40px !important;"><span>{{orders?.submittedCount || 0}}</span>
          <small>Submitted</small>
        </h1>
      </div>
    </div>
    <div class="col-md mb-2 mb-md-0" style="position: relative;">
      <div class="box">
        <h1 style="z-index: 1100;min-height: 40px !important;"><span>{{orders?.readyToShipCount || 0}}</span>
          <small>Ready to Ship</small>
        </h1>
      </div>
    </div>
    <div class="col-md mb-2 mb-md-0" style="position: relative;">
      <div class="box">
        <h1 style="z-index: 1100;min-height: 40px !important;"><span>{{orders?.shippedCount || 0}}</span>
          <small>Shipped</small>
        </h1>
      </div>
    </div>
    <div class="col-md mb-2 mb-md-0" style="position: relative;">
      <div class="box">
        <h1 style="z-index: 1100;min-height: 40px !important;"><span>{{orders?.deliveredCount || 0}}</span>
          <small>Delivered</small>
        </h1>
      </div>
    </div>
  </div>
</section>

<div [ngStyle]="{'display': requestPopup =='Y'? 'block' : 'none'}" style="overflow-y:auto"  [ngClass]="{'modal': requestPopup == 'Y'}"  class="modal fade show" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" style="padding-top:100px;">
  <div class="modal-dialog">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Confirmation</h4>
        <button type="button" class="close" data-dismiss="modal" (click)="closeRequestPopup()">&times;</button>
      </div>
      <div class="modal-body">
        <p>Do you want to submit a Withdraw request? </p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-delete" data-dismiss="modal" (click)="closeRequestPopup()">No</button>
        <button type="button" class="btn btn-edit ml-2" data-dismiss="modal" (click)="updateRequest()">Yes</button>
      </div>
    </div>
  </div>
</div>
